import { render, staticRenderFns } from "./IdCardView.vue?vue&type=template&id=d7c6753a&scoped=true"
import script from "./IdCardView.vue?vue&type=script&lang=js"
export * from "./IdCardView.vue?vue&type=script&lang=js"
import style0 from "./IdCardView.vue?vue&type=style&index=0&id=d7c6753a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7c6753a",
  null
  
)

export default component.exports